const LEGACY_HOSTS = ['belonging.lgbt', 'www.belonging.lgbt', 'belonging.network', 'www.belonging.network'];

export function normalizeBasePath(value) {
  if (!value || value === '/') return '';
  if (!/^\/(?:[a-zA-Z0-9_-]+\/?)*$/.test(value)) throw new Error('Invalid social base path');
  return value.replace(/\/+$/, '');
}

export function resolveBasePath(location, configured) {
  if (configured !== undefined) return normalizeBasePath(configured);
  for (const path of ['/social', '/belonging']) {
    if (location.pathname === path || location.pathname.startsWith(path + '/')) return path;
  }
  if (LEGACY_HOSTS.includes(location.hostname)) return '';
  return ['arawra.net', 'www.arawra.net'].includes(location.hostname) ? '/social' : '/belonging';
}

export const BASE_PATH = resolveBasePath(window.location, process.env.REACT_APP_SOCIAL_BASE_PATH);
export const APP_NAME = 'Arawra';
export const SITE_URL = 'https://arawra.net/social';
export const APP_URL = window.location.origin + BASE_PATH;
export const API_URL = process.env.REACT_APP_API_URL || APP_URL + '/api';
export const SOCKET_PATH = BASE_PATH + '/socket.io';
// Retain legacy sessions on their existing mount; never adopt another app's
// generic token/user fields on Arawra's shared game origin.
export function storageKeys(base = BASE_PATH) {
  return base === '' || base === '/belonging'
    ? { token: 'token', user: 'user', accounts: 'belonging_saved_accounts' }
    : { token: 'arawra_social_token', user: 'arawra_social_user', accounts: 'arawra_social_saved_accounts' };
}
const storage = storageKeys();
export const AUTH_TOKEN_KEY = storage.token;
export const AUTH_USER_KEY = storage.user;
export const SAVED_ACCOUNTS_KEY = storage.accounts;

export function routerTarget(to, base = BASE_PATH) {
  if (to && typeof to === 'object' && to.pathname) return { ...to, pathname: routerTarget(to.pathname, base) };
  if (typeof to !== 'string' || !base) return to;
  if (to === base) return '/';
  if (to.startsWith(base + '/') || to.startsWith(base + '?') || to.startsWith(base + '#')) return to.slice(base.length);
  return to;
}

export function mediaUrl(value, base = BASE_PATH) {
  if (typeof value !== 'string' || !value) return value;
  const ownAsset = /^\/(?:uploads|images|flags|Skills|tribe-icons|favicon)\//;
  const raw = /^(?:uploads|images|flags|Skills|tribe-icons|favicon)\//.test(value) ? '/' + value : value;
  const path = raw.startsWith('/belonging/') ? raw.slice('/belonging'.length) : raw;
  if (ownAsset.test(path)) return base + path;
  try {
    const url = new URL(raw);
    if (LEGACY_HOSTS.includes(url.hostname)) {
      const path = url.pathname.startsWith('/belonging/') ? url.pathname.slice('/belonging'.length) : url.pathname;
      if (ownAsset.test(path)) return base + path + url.search + url.hash;
    }
    if (url.origin === window.location.origin && url.pathname.startsWith('/uploads/')) return base + url.pathname + url.search + url.hash;
  } catch { /* Relative assets, data URLs and external media stay as authored. */ }
  return value;
}

// Display existing authored HTML without changing its stored serialization.
// The inert template preserves native media elements and unrelated attributes;
// only URLs owned by this app are resolved to its current mount.
export function richMediaHtml(value, base = BASE_PATH) {
  if (typeof value !== 'string' || !value || typeof document === 'undefined') return value;
  const template = document.createElement('template');
  template.innerHTML = value;
  for (const node of template.content.querySelectorAll('img[src],video[src],audio[src],source[src],video[poster],a[href]')) {
    for (const attr of ['src', 'poster', 'href']) {
      if (node.hasAttribute(attr)) node.setAttribute(attr, mediaUrl(node.getAttribute(attr), base));
    }
  }
  return template.innerHTML;
}
